import { useState, useMemo } from "react";
import { Box } from "@mui/material";
import { SidebarLayoutContext, SidebarLayoutContextData } from "@kaltura/ds-react-layouts";
import {
    HeaderMenu,
    HeaderMenuProps,
    HighContrastMenuItem,
    ThemeMenuItem,
    NavigationPanelProps,
    getStandaloneComponentRenderer,
} from "@kaltura/mediaspace-shared-layout";

export { HeaderMenu as Component, HighContrastMenuItem, ThemeMenuItem };
export { HeaderMoe } from "@kaltura/mediaspace-shared-layout";

/**
 * HeaderMenu and the portal ref for the NavigationPanel, to be used when there is no DsLayout.
 */
const HeaderMenuApp = (props: { headerProps: HeaderMenuProps; sidebarProps: NavigationPanelProps }) => {
    const [floatedContainerRef, setFloatedContainerRef] = useState<HTMLDivElement | null>(null);

    // mimic context of SidebarLayout used in DsLayout
    const contextData: SidebarLayoutContextData = useMemo(
        () => ({
            isEnabled: false,
            isOpened: false,
            setIsOpened: () => {},
            setActiveButtonId: () => {},
            originalTheme: undefined,
            floatedContainerRef,
        }),
        [floatedContainerRef]
    );

    return (
        <SidebarLayoutContext.Provider value={contextData}>
            <HeaderMenu {...props.headerProps} />
            <Box ref={setFloatedContainerRef}></Box>
        </SidebarLayoutContext.Provider>
    );
};

export const render = getStandaloneComponentRenderer(HeaderMenuApp, true);
